import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PluginHeaderButtonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginHeaderButtons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiddenPluginBoardButtons"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginHeaderButtons","document":PluginHeaderButtonsDocument}} as const;
export type PluginHeaderButtonsQueryVariables = Types.Exact<{
  idBoard: Types.Scalars['ID'];
}>;


export type PluginHeaderButtonsQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Types.Board_Prefs, 'hiddenPluginBoardButtons'>
    )> }
  )> }
);

/**
 * __usePluginHeaderButtonsQuery__
 *
 * To run a query within a React component, call `usePluginHeaderButtonsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginHeaderButtonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginHeaderButtonsQuery({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *   },
 * });
 */
export function usePluginHeaderButtonsQuery(
  baseOptions: TrelloQueryHookOptions<
    PluginHeaderButtonsQuery,
    PluginHeaderButtonsQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PluginHeaderButtonsDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PluginHeaderButtonsQuery,
    PluginHeaderButtonsQueryVariables
  >(PluginHeaderButtonsDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePluginHeaderButtonsLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PluginHeaderButtonsQuery,
    PluginHeaderButtonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PluginHeaderButtonsQuery,
    PluginHeaderButtonsQueryVariables
  >(PluginHeaderButtonsDocument, options);
}
export type PluginHeaderButtonsQueryHookResult = ReturnType<
  typeof usePluginHeaderButtonsQuery
>;
export type PluginHeaderButtonsLazyQueryHookResult = ReturnType<
  typeof usePluginHeaderButtonsLazyQuery
>;
export type PluginHeaderButtonsQueryResult = Apollo.QueryResult<
  PluginHeaderButtonsQuery,
  PluginHeaderButtonsQueryVariables
>;
